// test1973
(1973 && 0);
